// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + "styles" + ".bundle." + "71e03ff39ba97435d083" + ".css";
};